module.exports = __webpack_public_path__ + "img/nginx.6bf3a5c4.jpg";